import { render, staticRenderFns } from "./PlannedServiceEventListItem.vue?vue&type=template&id=27040b18&"
import script from "./PlannedServiceEventListItem.vue?vue&type=script&lang=js&"
export * from "./PlannedServiceEventListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports